<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        {{ agentName }}
        <span v-if="commisionNotInclude">
          (فروشهایی که شامل پورسانت نشده اند)
        </span>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding text-center" horizontal>
      <q-chip label="پورسانت" square clickable color="teal" text-color="white" size="lg">
        <q-chip dir="ltr" square class="q-ml-xs" color="red" text-color="white"
                :label="lodash.sumBy(items, item=>item.Porsand).toLocaleString()"/>
      </q-chip>

      <q-chip
          v-if="$store.state.roles.some(v=>['admin'].includes(v))"
          label="اختلاف خرید و فروش" square clickable color="teal" text-color="white" size="lg">
        <q-chip dir="ltr" square class="q-ml-xs" color="red" text-color="white"
                :label="lodash.sumBy(items, item=>item.DiffPrice).toLocaleString()"/>
      </q-chip>
      <q-btn label="فروشهایی که شامل پورسانت نشده اند" color="red"
             @click="showCommisionFinanceDocumentNotInclude" class="q-ma-xs"
             v-if="$store.state.roles.some(v=>['admin'].includes(v)) && !commisionNotInclude"
             text-color="white"
             icon="error"/>
      <q-btn label="صدور سند مالی پورسانت" color="indigo"
             flat
             :disable="preventPorsantDocument && preventPorsantDocument>0"
             @click="issueCommisionFinanceDocument" class="q-ma-xs"
             v-if="$store.state.roles.some(v=>['admin','can_issue_commision_finance_document'].includes(v))
             && items
             && items.length>0
             && !items[0].IssueUser
             && progressSalePrice>=salePrice/2
             && !commisionNotInclude
             && lodash.sumBy(items, item=>item.Porsand)>0"
             icon="attach_money"/>
    </q-card-section>
    <q-card-section v-if="items && items.length>0 && items[0].IssueUser">
      <q-banner class="bg-green-2 text-teal" inline-actions rounded>
        سند مالی پورسانت صادر شده است.
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-chip color="indigo" text-color="white" label="استان ها">
        <q-badge color="red" text-color="white" :label="statesList.length" floating/>
      </q-chip>
      <q-space/>
      <q-chip icon="location_city" v-for="(item) in statesList" :label="item.State_Name" :key="item.State_ID"
              square
              clickable>
        <q-badge color="green" text-color="white" class="q-ml-xs"
                 :label="item.totalSalePrice.toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-separator/>
      <q-chip color="indigo" text-color="white" label="شهر ها">
        <q-badge color="red" text-color="white" :label="citiesList.length" floating/>
      </q-chip>
      <q-space/>

      <q-chip icon="location_city" v-for="(item) in citiesList" :label="item.City_Name" :key="item.City_ID" square
              clickable>
        <q-badge color="green" text-color="white" class="q-ml-xs"
                 :label="item.totalSalePrice.toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-separator/>
      <q-chip color="indigo" text-color="white" label="اصناف">
        <q-badge color="red" text-color="white" :label="kindsList.length" floating/>
      </q-chip>
      <q-space/>

      <q-chip icon="location_city" text-color="white" color="blue-grey" v-for="(item) in kindsList"
              :label="item.CSKind_Name" :key="item.CSKind_ID" square
              clickable>
        <q-badge color="blue-grey" text-color="white" class="q-ml-xs text-bold text-italic"
                 :label="item.totalSalePrice.toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-chip color="indigo" text-color="white" label="گروه کالاها">
        <q-badge color="red" text-color="white" :label="groupsList.length" floating/>
      </q-chip>
      <q-space/>
      <q-separator/>
      <q-chip icon="group_work" text-color="white" color="blue-grey" v-for="(item) in groupsList"
              :label="item.Group_Name"
              :key="item.Group_ID" square
              clickable>
        <q-badge color="blue-grey" text-color="white" class="q-ml-xs text-bold text-italic"
                 :label="item.totalSalePrice.toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-chip color="indigo" text-color="white" label="مشتریان">
        <q-badge color="red" text-color="white" :label="groupsList.length" floating/>
      </q-chip>
      <q-separator/>
      <q-chip icon="person" text-color="white" color="blue-grey" v-for="(item) in customersList"
              :label="item.Cs_Name"
              :key="item.Cs_ID" square
              clickable>
        <q-badge color="blue-grey" text-color="white" class="q-ml-xs text-bold text-italic"
                 :label="item.totalSalePrice.toLocaleString()"/>
      </q-chip>
    </q-card-section>
    <q-card-section>
      <q-separator/>
      <q-table
          :data="lodash.orderBy(items, ['Sale_Num'], 'desc')"
          row-key="Sale_Num"
          flat
          wrap-cells
          dense
          :rows-per-page-options="[pagination.rowsPerPage]"
          :pagination.sync="pagination">
        <template v-slot:header>
          <tr class="text-center text-subtitle1">
            <td>عنوان گروه کالا</td>
            <td>شماره فاکتور</td>
            <td>کد کالا</td>
            <td>تعداد فروش</td>
            <td>مبلغ واحد</td>
            <td>مبلغ کل</td>
            <td>نام مشتری</td>
            <td>صنف</td>
            <td>استان</td>
            <td>شهر</td>
            <td>تعداد هدف</td>
            <td>سفارش گیرنده</td>
            <td>فاکتور کننده</td>
            <td v-if="$store.state.roles.some(v=>['admin','can_sea_goods_profit'].includes(v))">اختلاف خرید
              و فروش
            </td>
            <td>پورسانت</td>
          </tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="text-center">
            <td class="text-left">
              <q-card flat>
                <q-card-section class="no-padding">
                  <q-chip :label="props.row.Group_Name" clickable color="indigo" text-color="white"/>
                  <q-space/>
                  <q-chip outline :label="props.row.Goods_Name" clickable color="indigo"
                          text-color="white"/>
                </q-card-section>
              </q-card>
            </td>
            <td>
              <q-chip icon="pin" :label="props.row.Sale_Num" @click="showDetails(props.row)" square
                      clickable
                      color="red-10" text-color="white"/>
            </td>
            <td>
              <q-chip :label="props.row.Goods_Code" @click="showProductInfo(props.row)" square clickable
                      color="red"
                      text-color="white"/>
            </td>

            <td>
              <q-chip :label="props.row.SaleG_Count" square clickable color="indigo" text-color="white"/>
            </td>
            <td>
              <q-chip icon="attach_money" :label="props.row.SaleG_PricePure.toLocaleString()" square
                      clickable
                      color="green"
                      text-color="white"/>
            </td>
            <td>
              <q-chip icon="attach_money"
                      :label="(props.row.SaleG_Count * props.row.SaleG_PricePure).toLocaleString()"
                      square clickable color="green"
                      text-color="white"/>
            </td>
            <td>
              <q-chip icon="person" :label="props.row.Cs_Name" square clickable
                      @click="showCustomerInfo(props.row)"/>
            </td>
            <td>
              <q-chip :label="props.row.CSKind_Name" clickable color="brown"
                      text-color="white"/>
            </td>
            <td>
              <q-chip icon="location_city" :label="props.row.State_Name" square clickable color="indigo"
                      text-color="white"/>
            </td>
            <td>
              <q-chip icon="location_city" :label="props.row.City_Name" square clickable color="indigo"
                      text-color="white"/>
            </td>
            <td>
              <q-chip icon="target" v-if="props.row.targetCount && props.row.targetCount>0"
                      :label="props.row.targetCount" square
                      clickable color="indigo"
                      text-color="white"/>
            </td>
            <td>
              <q-chip icon="support_agent" :label="props.row.OrderUsername"
                      square clickable
                      color="indigo"
                      text-color="white"/>
            </td>
            <td>
              <q-chip icon="support_agent" :label="props.row.SaleUsername"
                      square clickable
                      color="indigo"
                      text-color="white"/>
            </td>
            <td v-if="$store.state.roles.some(v=>['admin','can_sea_goods_profit'].includes(v))">
              <q-chip dir="ltr" icon-right="attach_money" :label="props.row.DiffPrice.toLocaleString()" square
                      clickable
                      color="green"
                      text-color="white"/>
            </td>
            <td>
              <q-chip dir="ltr" icon-right="attach_money" v-if="props.row.Porsand"
                      :label="props.row.Porsand.toLocaleString()"
                      square clickable color="green"
                      text-color="white"/>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog
        maximized
        v-model="showOrderDetailsDialog">
      <FactorDetails :sale-state="selectedSaleStat" :sale-num="selectedSaleNum"
                     :sale-kind="1" :factor-items="factorItems"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="customerInfoDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>
    <q-dialog :maximized="$q.screen.lt.md" v-model="productDetailDialog">
      <ProductDetail :product="selectedProduct"/>
    </q-dialog>
    <q-dialog maximized v-model="commisionFinanceDocumentNotIncludeDialog">
      <AgentsCommisionFactorListDesktop :target-id="targetId" v-if="!$q.screen.lt.md" :agent-name="agentName"
                                        :user-id="userId" :end-date="endDate"
                                        :sale-price="salePrice"
                                        :prevent-porsant-document="preventPorsantDocument"
                                        :progress-sale-price="progressSalePrice"
                                        :commision-not-include="true"
                                        :start-date="startDate"/>
    </q-dialog>
  </q-card>
</template>

<script>
import FactorDetails from "@/components/Factor/FactorDetails";
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "AgentsCommisionFactorListDesktop",
  components: {ProductDetail, CustomerInfo, FactorDetails},
  props: {
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    userId: {
      type: Number,
      required: true
    },
    agentName: {
      type: String,
      required: true
    },
    targetId: {
      type: String,
      required: true
    },
    salePrice: {
      type: Number,
      required: true
    },
    progressSalePrice: {
      type: Number,
      required: true
    },
    preventPorsantDocument: {
      type: Number,
      default: () => true
    },
    commisionNotInclude: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      groupList: [],
      items: [],
      customerInfoDialog: false,
      pagination: {
        rowsPerPage: 10
      },
      factorItems: [],
      selectedSaleNum: undefined,
      selectedFactor: undefined,
      showOrderDetailsDialog: false,
      selectedSaleStat: 1,
      selectedCustomer: undefined,
      statesList: [],
      citiesList: [],
      kindsList: [],
      groupsList: [],
      productDetailDialog: false,
      selectedProduct: undefined,
      customersList: [],
      commisionFinanceDocumentNotIncludeDialog: false
    }
  },
  methods: {
    ...mapActions({
      getFactorItems: 'Orders/getFactorItems',
      getCustomerInfo: 'Customers/get_customer_info',
      getItems: 'Agents/getCommisionFactorList',
      getItemsNotInclude: 'Agents/getCommisionFactorListNotInclude',
      getProductInfo: 'Products/getProductInfo',
      addCommisionFianceDocument: 'Agents/addCommissionFinanceDocument'
    }),
    showCommisionFinanceDocumentNotInclude() {
      this.commisionFinanceDocumentNotIncludeDialog = true
    },
    issueCommisionFinanceDocument() {
      this.addCommisionFianceDocument({
        price: this.lodash.sumBy(this.items, item => item.Porsand),
        userId: this.userId,
        targetId: this.targetId
      }).then((res) => {
        if (res.result === 1) {
          this.items[0].IssueUser = this.$store.state.userId
        }
      })
    },
    showProductInfo(row) {
      this.getProductInfo(row.Goods_ID).then((res) => {
        this.selectedProduct = res[0]
        this.productDetailDialog = true
      })
    },
    showDetails(row) {
      this.getFactorItems({
        sale_num: row.Sale_Num,
        sale_kind: 1
      }).then((res) => {
        this.factorItems = res;
        this.selectedSaleNum = row.Sale_Num;
        this.selectedFactor = row
        this.showOrderDetailsDialog = true;
      })
    },
    showCustomerInfo(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.customerInfoDialog = true;
      })
    },
  },
  created() {
    if (this.commisionNotInclude) {
      this.getItemsNotInclude({
        startDate: this.startDate.replaceAll("/", "-"),
        endDate: this.endDate.replaceAll("/", "-"),
        userId: this.userId
      }).then((res) => {
        this.items = res

        this.statesList = this.lodash(this.items).groupBy('State_Name').map(arr => {
          const {State_ID, State_Name} = arr[0]
          return {
            State_ID,
            State_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()

        this.citiesList = this.lodash(this.items).groupBy('City_Name').map(arr => {
          const {City_ID, City_Name} = arr[0]
          return {
            City_ID,
            City_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()

        this.kindsList = this.lodash(this.items).groupBy('CSKind_Name').map(arr => {
          const {CSKind_ID, CSKind_Name} = arr[0]
          return {
            CSKind_ID,
            CSKind_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()

        this.groupsList = this.lodash(this.items).groupBy('Group_Name').map(arr => {
          const {Group_ID, Group_Name} = arr[0]
          return {
            Group_ID,
            Group_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()

        this.customersList = this.lodash(this.items).groupBy('Cs_Name').map(arr => {
          const {Cs_ID, Cs_Name} = arr[0]
          return {
            Cs_ID,
            Cs_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()
      })
    } else {
      this.getItems({
        startDate: this.startDate.replaceAll("/", "-"),
        endDate: this.endDate.replaceAll("/", "-"),
        userId: this.userId
      }).then((res) => {
        this.items = res

        this.statesList = this.lodash(this.items).groupBy('State_Name').map(arr => {
          const {State_ID, State_Name} = arr[0]
          return {
            State_ID,
            State_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()

        this.citiesList = this.lodash(this.items).groupBy('City_Name').map(arr => {
          const {City_ID, City_Name} = arr[0]
          return {
            City_ID,
            City_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()

        this.kindsList = this.lodash(this.items).groupBy('CSKind_Name').map(arr => {
          const {CSKind_ID, CSKind_Name} = arr[0]
          return {
            CSKind_ID,
            CSKind_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()

        this.groupsList = this.lodash(this.items).groupBy('Group_Name').map(arr => {
          const {Group_ID, Group_Name} = arr[0]
          return {
            Group_ID,
            Group_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()

        this.customersList = this.lodash(this.items).groupBy('Cs_Name').map(arr => {
          const {Cs_ID, Cs_Name} = arr[0]
          return {
            Cs_ID,
            Cs_Name,
            totalSalePrice: this.lodash(arr).sumBy(item => item.SaleG_Count * item.SaleG_PricePure)
          };
        }).value()
      })
    }
  }
}
</script>

<style scoped>

</style>